import React from 'react';
import {
    Typography,
    Box,
    Avatar,
} from "@mui/material";

import { _date } from "../../../utils/helpers";

export const EventColumns = () => [
    {
        id: "name",
        label: "Name",
        render: (value, row) => {
            const name = row.name_en || row.name_hy || row.name_ru || 'No name';
            return (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    {row.thumbnail_url && (
                        <Avatar
                            variant="rounded"
                            src={row.thumbnail_url}
                            sx={{ width: 56, height: 56 }}
                        />
                    )}
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                        {name}
                    </Typography>
                </Box>
            );
        }
    },
    {
        id: "event_date",
        label: "Date",
        render: (value) => {
            return (
                <Typography sx={{ color: "text.secondary", textAlign: 'center' }}>
                    {_date(value, { relative: false })}
                </Typography>
            );
        }
    },
    {
        id: "media",
        label: "Media",
        render: (value, row) => {
            const count = Array.isArray(row.media) ? row.media.length : 0;
            return (
                <Typography sx={{ textAlign: 'center' }}>
                    {count}
                </Typography>
            );
        }
    },
];
